
export interface SelectOption {
  value: string;
  label: string;
}

export interface IAwardRow {
  id: number;
  key: string;
  awardYear: string;
  empNo: string;
  empNm: string;
  postCd: string;
  postNm: string;
  deptNm: string;
  awardCd: string | null;
  awardVal: string | null;
  lstChgEmpNo: string;
  lstChgDtm: string;
}

export interface IEvl0112mInquiryCnds {
  awardYear: string;
  empNm: string;
  deptNm: string;
  postCd: string;
  awardCd: string;
}

export interface IEvl0112mState {
  rows: IAwardRow[];
  inquiryCnds: IEvl0112mInquiryCnds;
  posClsMap: Record<string, string>;
  posOptions: SelectOption[];
}

export type SortKey =
  | "awardYear"
  | "empNm"
  | "postNm"
  | "deptNm"
  | "awardCd"
  | "awardVal"
  | "";

export type AwardCodeOption = {
  value: string;
  label: string;
};

export const AWARD_MAX_VALUE = 100000000;

export const INST_OPTIONS = [
  { value: "001", label: "투게더솔루션" },
  { value: "002", label: "위드정보" },
];

export const PAGE_SIZE = 10;

export const getYearOptions = () => {
  const START_YEAR = 2020;
  const currentYear = new Date().getFullYear();

  return Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => {
    const year = String(currentYear - i);
    return {
      value: year,
      label: `${year}년`,
    };
  });
};